import React, { useEffect, useState } from "react";
import { Grid, Paper, Typography, Divider } from "@mui/material";
import UpcomingAppointmentsTable from "../../components/doctor/UpcomingAppointmentsTable";
import WorkingHoursForm from "../../components/doctor/WorkingHoursForm";
import AppointmentDetailDialog from "../../components/doctor/AppointmentDetailDialog";
import PatientHistoryDialog from "../../components/doctor/PatientHistoryDialog";
import DoctorsScheduleTable from "src/components/doctor/DoctorsScheduleTable";

const DoctorDashboard = () => {
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [showAppointmentDialog, setShowAppointmentDialog] = useState(false);
  const [showHistoryDialog, setShowHistoryDialog] = useState(false);

  const handleViewDetails = (appointment) => {
    setSelectedAppointment(appointment);
    setShowAppointmentDialog(true);
  };

  const handleViewHistory = (appointment) => {
    setSelectedAppointment(appointment);
    setShowHistoryDialog(true);
  };

  return (
    <Grid container spacing={3} sx={{ p: 3 }}>
      {/* Left: Working Hours + Holiday Manager */}
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 2, mb: 3 }}>
          <Typography variant="h6">Working Hours & Max Slots</Typography>
          <Divider sx={{ my: 1 }} />
          <WorkingHoursForm />
        </Paper>
      </Grid>

      {/* Right: Upcoming Appointments */}
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6">Upcoming Appointments</Typography>
          <Divider sx={{ my: 1 }} />
          <UpcomingAppointmentsTable
            onViewDetails={handleViewDetails}
            onViewHistory={handleViewHistory}
          />
        </Paper>
      </Grid>

      {/* Dialogs */}
      <AppointmentDetailDialog
        open={showAppointmentDialog}
        onClose={() => setShowAppointmentDialog(false)}
        appointment={selectedAppointment}
      />
      <PatientHistoryDialog
        open={showHistoryDialog}
        onClose={() => setShowHistoryDialog(false)}
        appointment={selectedAppointment}
      />
    </Grid>
  );
};

export default DoctorDashboard;
